/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BillingSourceSystem {
  CCP = "CCP",
  HAMS = "HAMS",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TrialDetailsQuery
// ====================================================

export interface TrialDetailsQuery_license {
  billingSourceSystem: BillingSourceSystem | null;
  licenseConsumingUserCount: number;
  trialEndDate: string | null;
}

export interface TrialDetailsQuery {
  license: TrialDetailsQuery_license | null;
}
